import React, { useState } from "react";
import "./Index.css";
import FilterJob from "../ApplyJob/FilterJob/FilterJob";
import JobCards from "../ApplyJob/JobCards/JobCards";
import "../ApplyJob/JobCards/JobCards.css";
import "../ApplyJob/ApplyJob.css";
export default function Index() {
  const [isFilterShow, setIsFilterShow] = useState(false);
  const handleSetFilter = (data) => {
    setIsFilterShow(data);
  };
  return (
    <>
      <div className="suggested-jobs-main">
        <div
          className={`left-job-section responsiveFilterBox px-1 py-1 ${
            isFilterShow && "d-block"
          }`}
        >
          <FilterJob
            isFilterShow={isFilterShow}
            handleSetFilter={handleSetFilter}
          />
        </div>

        <div className="suggestedJobcards-container">
          <JobCards handleSetFilter={handleSetFilter} />
        </div>
      </div>
    </>
  );
}
